export default __webpack_public_path__ + "static/media/plain-sticker-pa.7deb5920.png";